module.exports = __webpack_public_path__ + "media/images/badges/cyclebar/grey/RideClub_Milestones_App_500-Grey-b4f7c3dd7614b8954b7bc3994fc0a46c.png";